import styled, { css } from 'styled-components';
import { PDialogV2 } from 'components/prime/PDialogV2/PDialogV2';
import { colourPalette, gap, hexToRGBA, padding } from 'styles/styles';

export const PopupStyle = {
  Popup: styled(PDialogV2)`
    .p-dialog-close {
      position: absolute;
      top: ${gap.gap3};
      right: ${gap.gap3};
    }
    .p-dialog-header {
      padding: ${padding.paddingNone};
    }
    .p-dialog-footer {
      padding: ${padding.paddingNone} ${padding.paddingXL} ${padding.paddingXL};
    }
    .p-dialog-body-scroller::before,
    .p-dialog-body-scroller::after {
      height: ${gap.gap2};
    }
    .p-dialog-body-content {
      color: ${colourPalette.neutral500};
      padding: ${padding.paddingNone} ${padding.paddingXL};
    }
    .popup-header {
      img {
        height: 240px;
        width: 100%;
        object-fit: cover;
      }
    }
  `,
};

export const PopupGlobalStyle = css`
  .popup-mask {
    background-color: ${hexToRGBA(colourPalette.neutral0, 0.6)} !important;
    backdrop-filter: blur(4px);
  }
`;
